<template>
    <v-container class="pa-0">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    style="width: auto;height: auto;"
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="openLink('https://abriron.com/%d8%a2%d9%85%d9%88%d8%b2%d8%b4-%d9%86%d8%b1%d9%85-%d8%a7%d9%81%d8%b2%d8%a7%d8%b1-%d8%ad%d8%b3%d8%a7%d8%a8%d8%af%d8%a7%d8%b1%db%8c-%d8%a2%d9%86%d9%84%d8%a7%db%8c%d9%86/')"
                >
                    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 18.75C5.175 18.75 1.25 14.825 1.25 10C1.25 5.175 5.175 1.25 10 1.25C14.825 1.25 18.75 5.175 18.75 10C18.75 14.825 14.825 18.75 10 18.75ZM10 2.5C5.8625 2.5 2.5 5.8625 2.5 10C2.5 14.1375 5.8625 17.5 10 17.5C14.1375 17.5 17.5 14.1375 17.5 10C17.5 5.8625 14.1375 2.5 10 2.5Z" fill="black"/>
                    <path d="M10 5.625C8.6125 5.625 7.5 6.7375 7.5 8.125H8.75C8.75 7.4375 9.3125 6.875 10 6.875C10.6875 6.875 11.25 7.4375 11.25 8.125C11.25 9.375 9.375 9.225 9.375 11.25H10.625C10.625 9.85 12.5 9.6875 12.5 8.125C12.5 6.7375 11.3875 5.625 10 5.625Z" fill="black"/>
                    <path d="M10.0016 14.5246C10.4296 14.5246 10.7766 14.1776 10.7766 13.7496C10.7766 13.3216 10.4296 12.9746 10.0016 12.9746C9.57354 12.9746 9.22656 13.3216 9.22656 13.7496C9.22656 14.1776 9.57354 14.5246 10.0016 14.5246Z" fill="black"/>
                    <path d="M8.125 8.75C8.47018 8.75 8.75 8.47018 8.75 8.125C8.75 7.77982 8.47018 7.5 8.125 7.5C7.77982 7.5 7.5 7.77982 7.5 8.125C7.5 8.47018 7.77982 8.75 8.125 8.75Z" fill="black"/>
                    <path d="M10 11.875C10.3452 11.875 10.625 11.5952 10.625 11.25C10.625 10.9048 10.3452 10.625 10 10.625C9.65482 10.625 9.375 10.9048 9.375 11.25C9.375 11.5952 9.65482 11.875 10 11.875Z" fill="black"/>
                    </svg>
                </v-btn>
            </template>
            <span>{{ $t('learn') }}</span>
        </v-tooltip>
    </v-container>
</template>

<script>
export default {
  methods: {
    openLink (link) {
      window.open(link, '_blank')
    }
  }
}
</script>

<style scoped>

</style>
